import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, Avatar } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import { IdeaCss } from '../IdeaCss';
import { history } from '../../../helpers';
import { StepIdea } from '../../Shared';

export function IdeaDetails() {
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { ideasStepsFlux } = useSelector(state => state.domains);
  const { ideaDetailsFlux } = useSelector(state => state.fluxIdeas);
  
  function goToChallenge() {
    history.push(`/challenge/detail/${ideaDetailsFlux.challenge._id}`);
  }

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.cardSmall}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <DescriptionIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">{t('detalhes')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">{t('etapa')}</Typography>
            <StepIdea step={ideasStepsFlux.find(({ _id }) => _id === ideaDetailsFlux?.currentStepFlux?.ideaStepFlux?._id) || ideaDetailsFlux?.statusIdea} />
          </Grid>
          {ideaDetailsFlux?.code && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('codigo')}</Typography>
              <Typography variant="body2">{ideaDetailsFlux.code}</Typography>
            </Grid>
          )}
          {/* {ideaDetailsFlux?.methodology?.name?.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('tipo_da_ideia')}</Typography>
              <Typography variant="body2">{ideaDetailsFlux?.methodology?.name}</Typography>
            </Grid>
          )}
          {ideaDetailsFlux?.suggestionsRegarding?.name && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('ambito')}</Typography> 
              <Typography variant="body2">{ideaDetailsFlux?.suggestionsRegarding?.name}</Typography>
            </Grid>
          )} */}
          {ideaDetailsFlux.challenge?.name && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('desafio')}</Typography>
              <Typography variant="body2" className={classes.challengeLink} onClick={goToChallenge}>
                {ideaDetailsFlux.challenge.name}
              </Typography>
            </Grid>
          )}
          {ideaDetailsFlux?.personalizedClassifications && ideaDetailsFlux?.personalizedClassifications.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('classificacao')}</Typography>
              <Box display="flex" flexDirection="column" justifyContent="flex-start">
                {ideaDetailsFlux?.personalizedClassifications?.map((classification, index) => (
                  <Typography variant="body2" key={index}>- {classification.name}</Typography>
                ))}
              </Box>
            </Grid>
          )}
        </Grid>
      </Card>
    </Grid>
  );
}
